<template>
  <div
    class="file-upload-wrapper"
    @click="selectFile"
    @dragenter.stop.prevent
    @dragover.stop.prevent
    @dragleave.stop.prevent
    @drop.prevent.stop="onFileDrop"
    :class="{ error: showError, disabled: disabled }"
  >
    <template v-if="state === 0">
      <section class="no-file" v-if="type === 'image'">
        <img src="../assets/icon/image-upload.png" /><br />
        <span class="tip image">上传图片</span>
      </section>
      <section class="no-file" v-else>
        <img src="../assets/icon/file-upload.png" /><br />
        <span class="tip">上传文件</span>
      </section>
    </template>
    <template v-else-if="state === 1">
      <section class="no-file">
        <div class="uploading"></div>
        <br />
        <span class="tip">上传中...</span>
      </section>
    </template>
    <template v-else>
      <section
        class="image-file"
        v-if="type === 'image'"
        :style="{ backgroundImage: renderImageFile() }"
      >
        <div class="replace-btn">替换图片</div>
      </section>
      <section class="normal-file" v-else>
        <span>{{ renderNormalFile() }}</span>
        <div class="replace-btn">替换文件</div>
      </section>
    </template>
    <input
      :accept="accept"
      ref="input"
      type="file"
      style="display: none"
      @change="onFileSelected"
    />
  </div>
</template>

<script>
import ArticleImage from '@/assets/article.svg'
export default {
  props: {
    accept: {
      type: String,
      default: '*'
    },
    uploader: {
      type: Function,
      default: (file) => {
        console.log(file)
      }
    },
    type: { // image file
      type: String
    },
    showError: {
      type: Boolean,
      default() {
        return false
      }
    },
    source: {
      type: String
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    let state = 0
    if (this.source) state = 2
    return {
      state // 0 select 1 uploading 2 review
    }
  },
  methods: {
    selectFile() {
      if (this.disabled) return
      const input = this.$refs['input']
      input.value = null
      this.$refs['input'].click()
    },
    onFileDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const file = e.dataTransfer.files[0]
      this.uploadFile(file)
    },
    onFileSelected(e) {
      const file = e.target.files[0]
      this.uploadFile(file)
    },
    uploadFile(file) {
      if (!file) return
      const filename = file.name
      const ext = filename.split('.').pop()
      const accept = this.accept.split(',')
      if (!accept.includes(`.${ext}`)) {
        this.$message({
          content: `文件格式不支持，仅支持 ${accept.join(' ')}`,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        return
      }
      this.state = 1
      this.uploader(file).then(url => {
        if (url) {
          this.state = 2
          this.$emit('complete', url)
        } else {
          if (this.source) {
            this.state = 2
          } else {
            this.state = 0
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
    renderImageFile() {
      const n = new URL(this.source)
      const ext = n.pathname.split('.').pop()
      if (this.accept.includes(ext)) {
        return `url(${this.replaceHTTPResource(this.source)})`
      } else {
        return `url(${this.replaceHTTPResource(ArticleImage)})`
      }
    },
    renderNormalFile() {
      // return this.source.split('/').pop()
      return '已上传'
    }
  }
}
</script>

<style lang="scss" scoped>
.file-upload-wrapper {
  border: 1px dashed #e7e7e7;
  border-radius: 4px;
  width: 180px;
  height: 135px;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }

  &.error {
    border-color: #fa5a57;
  }

  .no-file {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    img {
      display: block;
      width: 28px;
      height: 28px;
    }

    .uploading {
      display: block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      animation: rotate 0.8s infinite linear;
      border: 2px solid #cfd8e0;
      border-right-color: transparent;
    }

    .tip {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #00a1d6;
      letter-spacing: 0;
      text-align: center;
      display: inline-block;

      &.image {
        color: #999999;
      }
    }
  }

  .image-file,
  .normal-file {
    width: 100%;
    height: 100%;
    position: relative;
    .replace-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      background-color: rgba($color: #000000, $alpha: 0.4);
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
    }
  }

  .normal-file {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #999999;
    word-break: break-word;
    font-size: 14px;
    padding: 0 20px 30px 20px;
    box-sizing: border-box;
  }

  .image-file {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
</style>
